(function() {
  const TGLProduct = window.TGLProduct = window.TGLProduct || {};

  const SELECTORS = {
    productSection: '[data-product-section]',
    productData: '[data-product-json]',
    galleryThumb: '[data-gallery-thumb]',
    galleryThumbnails: '[data-gallery-thumbnails]',
    galleryIndicators: '[data-gallery-indicators]',
    galleryMain: '[data-gallery-main]',
    galleryPrev: '[data-gallery-prev]',
    galleryNext: '[data-gallery-next]',
    mainImage: '[data-main-image]',
    sizeButton: '[data-size-button]',
    colorSwatch: '[data-color-swatch]',
    sizeGuideOpen: '[data-open-size-guide]',
    sizeGuideDetails: '[data-size-guide-details]'
  };

  const CLASSNAMES = {
    activeThumb: 'active',
    selected: 'selected',
    sizeGuideOpen: 'active'
  };

  function parseSectionData(section) {
    const dataEl = section.querySelector(SELECTORS.productData);
    if (!dataEl) return null;

    try {
      return JSON.parse(dataEl.textContent.trim());
    } catch (error) {
      console.warn('Unable to parse product data JSON', error);
      return null;
    }
  }

  function formatMoney(cents, moneyFormat, currency) {
    const value = Number(cents || 0);

    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(value, moneyFormat);
    }

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD'
      }).format(value / 100);
    } catch (_) {
      return `${value / 100}`;
    }
  }

  function resizeShopifyImage(src, size) {
    if (!src || typeof src !== 'string') return src;
    const [url, query] = src.split('?');
    const sized = url.replace(/(\.[^./]+)$/, `_${size}x$1`);
    return query ? `${sized}?${query}` : sized;
  }

  function setActive(elements, activeEl) {
    elements.forEach((el) => el.classList.remove(CLASSNAMES.selected));
    if (activeEl) {
      activeEl.classList.add(CLASSNAMES.selected);
    }
  }

  TGLProduct.SELECTORS = SELECTORS;
  TGLProduct.CLASSNAMES = CLASSNAMES;
  TGLProduct.parseSectionData = parseSectionData;
  TGLProduct.formatMoney = formatMoney;
  TGLProduct.resizeShopifyImage = resizeShopifyImage;
  TGLProduct.setActive = setActive;
})();
